// Loosely typed because it is read off persisted jsonb columns.
export type CreativeBoostContext = {
  creativeBoost?: boolean | null;
};

// Omitted when off, like templateSelectionToContext: an absent key already
// reads as off, so surfaces that never render the toggle send nothing.
export function creativeBoostToContext(enabled: boolean): {
  creativeBoost?: boolean;
} {
  return enabled ? { creativeBoost: true } : {};
}

export function creativeBoostFromContext(
  ctx: CreativeBoostContext | null | undefined,
): boolean {
  return ctx?.creativeBoost === true;
}
